export default function (
  translationPrefix: string,
  payload?: string[],
) {
  if (!payload) {
    return []
  }

  const { $i18n } = useNuxtApp()
  return payload.map(key => ({
    label: $i18n.t(`${translationPrefix}.${key}`),
    value: key,
  }))
}
